import Axios from 'axios';

// import { IConnectionAuth, IInvoice, IPlan, IWorkspaceIntegration, TIntegrationCategory, IConnection } from '../models/Unified';
// import { notifyError } from './notify';

export const APIURL =
    // ['localhost'].indexOf(window.location.hostname) > -1 || window.location.hostname.indexOf('ngrok.io') > -1
    // ?
    // 'http://localhost:8000/';
    // :
    'https://api.unified.to/';

let TOKEN = '';

export function setApiToken(t: string) {
    TOKEN = t;
}

function getAuth(mock = false) {
    if (!TOKEN || mock) {
        return {
            headers: {
                'x-mock': true,
            },
        };
    }

    return {
        headers: {
            Authorization: `Bearer ${TOKEN}`,
        },
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function get<T>(method: string, params?: any, mock?: false): Promise<T | undefined> {
    try {
        const options = { ...getAuth(mock), params };
        // console.log('get.options', options);
        const result = await Axios.get(APIURL + method, options);

        return result ? result.data || [] : [];
    } catch (err) {
        // error(err);
        return undefined;
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function post<T>(method: string, data?: any, params?: any, mock?: false): Promise<T | undefined> {
    try {
        const options = { ...getAuth(mock), params };
        const result = await Axios.post(APIURL + method, data, options);
        return result ? result.data : ({} as T);
    } catch (err) {
        return;
    }
}

// used by API explorer

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function _call<T>(method: string, path: string, data?: any, params?: any, mock?: boolean): Promise<T | undefined> {
    const options = { ...getAuth(mock), params, data, method };
    console.log(`axios.${method}.${path}`, options, !!TOKEN);
    const result = await Axios(APIURL + (path.startsWith('/') ? path.substring(1) : path), options);
    console.log('axios.result', result);
    return result?.data;
}
